// The three documents the portal offers that are not a client's report: the
// two scope templates and the user guide.
//
// They live in back-ratings' bucket, and the portal used to link them
// anonymously. Phase 3 of the signed URLs closed every object under
// `reportes/` on 2026-09-22, which this repository asked for, so all three
// answered 403 until back-ratings #53 gave them a signing endpoint on
// 2026-09-25. The portal asks for a URL by key and fetches it with no
// credential, exactly as it does for a report.
//
// A key is the whole of the interface: no path leaves this file, so the
// portal cannot ask the back to sign an object of its choosing.
import { API_DEFAULT } from './settings';
import { API } from './routes';

export const DOCUMENTS = {
  scopeTemplatePost: { key: 'scope-template-post', name: 'template_alcances.xlsx' },
  scopeTemplatePre: { key: 'scope-template-pre', name: 'template_alcances_pre.xlsx' },
  userGuide: { key: 'user-guide', name: 'Manual CNC RPD Ratings 2025 43M.pdf' },
  certificate: { key: 'certificate', name: 'Certificado_Nagra.pdf' },
};

// The URL the back signs for a document, or null when it will not sign one.
// A 401 refreshes the session once and asks again. The URL lives fifteen
// minutes, so it is asked for when it is about to be used, never kept.
export const signedDocumentUrl = async (document, session) => {
  const { accessToken, setAccessToken, getAccessTokenWithRefresh } = session;

  const ask = (access) => fetch(`${API_DEFAULT}/${API.documentUrl(document.key)}`, {
    headers: { "Authorization": "Bearer " + access },
  });

  try {
    let signed = await ask(accessToken);
    if (signed.status === 401) {
      const newAccess = await getAccessTokenWithRefresh();
      if (!newAccess) return null;
      setAccessToken(newAccess);
      localStorage.setItem('accessToken', newAccess);
      signed = await ask(newAccess);
    }
    if (!signed.ok) return null;

    const { url } = await signed.json();
    return url || null;
  } catch (e) {
    return null;
  }
};

// Asks the back to sign this document and fetches it. false when either step
// fails — an expired session, a key the back does not know (404), a signature
// it could not make (503), or a bucket that refuses the URL — so the caller
// says so instead of handing the client whatever came back. Before
// 2026-09-25 the guide saved Google's XML error under the name of a PDF.
export const fetchDocument = async (document, saveAs, session) => {
  const url = await signedDocumentUrl(document, session);
  if (!url) return false;

  try {
    const res = await fetch(url);
    if (!res.ok) return false;

    saveAs(await res.blob(), document.name);
    return true;
  } catch (e) {
    return false;
  }
};
